import { Segment } from 'semantic-ui-react';
import styled from 'styled-components';
import FlexBoxTmp from './FlexBox';

const FlexBox = styled(FlexBoxTmp)`
	justify-content: space-evenly;
	text-align: center;
`;

const Header = styled.h5`
	padding: 0;
	margin: 0 0 5px 0;
`;

function DetailsSegment({ details }) {
	return (
		<Segment raised>
			<FlexBox>
				{details.map((detail, i) => {
					return (
						<div key={i}>
							<Header>{detail.header}</Header>
							{!detail.handler &&	<p>{detail.title}</p>}
							{detail.handler && <p onClick={() => detail.handler(detail.params)}>{detail.title}</p>}
						</div>
					)
				})}
			</FlexBox>
		</Segment>
	);
}

export default DetailsSegment;
